import _ from 'lodash'
import { fmtPercent } from '@com/utils/data-format.js'

const defaultQuery = (query = {}) => {
  return {
    page_size: query.page_size ? query.page_size : 15,
    page: query.page ? query.page : 1,
  }
}

const platforms = [
  {
    label: 'iOS',
    value: 2,
  },
  {
    label: 'Android',
    value: 1,
  },
]

const trafficTypeOptions = [
  {
    label: 'sdk',
    value: 1,
  },
  {
    label: 'adx',
    value: 2,
  },
  {
    label: 'online',
    value: 3,
  },
]

const adTypesOptions = [
  {
    label: 'interstitial video',
    value: 1,
  },
  {
    label: 'rewarded video',
    value: 2,
  },
]

// 素材类型
import { categories } from '@/common/material-metadata'

export default {
  computed: {
    formItemList() {
      const self = this
      const list = {
        tz: {
          type: 'select',
          prop: 'tz',
          params: {
            placeholder: '时区',
            clearable: true,
            options: this.timeZoneList,
          },
        },
        time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'time',
          class: 'date-picker',
          params: {
            clearable: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            handleBlur: () => {
              self.selectDate = ''
            },
            pickerOptions: {
              /* eslint-disable no-mixed-operators */
              // 限定只能选择前90天的日期
              disabledDate(time) {
                if (self.selectDate) {
                  const days = 31 * 24 * 3600 * 1000
                  return (
                    time.getTime() < self.selectDate ||
                    time.getTime() > self.selectDate + days
                  )
                }
                return false
              },
              onPick: ({ maxDate, minDate }) => {
                self.selectDate = minDate.getTime()
                if (maxDate) {
                  self.selectDate = ''
                }
              },
              shortcuts: [
                {
                  text: '最近三天',
                  onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
                    picker.$emit('pick', [start, end])
                  },
                },
                {
                  text: this.$t('form.pastWeek'),
                  onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                    picker.$emit('pick', [start, end])
                  },
                },
                {
                  text: '最近半个月',
                  onClick(picker) {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
                    picker.$emit('pick', [start, end])
                  },
                },
              ],
              /* eslint-enable no-mixed-operators */
            },
          },
        },
        agg_type: {
          type: 'select',
          prop: 'agg_type',
          params: {
            placeholder: '数据聚合维度',
            options: [
              {
                value: 'sum',
                label: '汇总',
              },
              {
                value: 'date',
                label: '分天',
              },
            ],
          },
        },
        creative_types: {
          type: 'select',
          prop: 'creative_types',
          params: {
            placeholder: '请选择素材类型',
            clearable: true,
            options: categories,
          },
        },
        ss_adv_ids: {
          prop: 'ss_adv_ids',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            multiple: true,
            filterable: true,
            collapseTags: true,
            class: 'search-filter-select',
          },
        },
        pt_adv_ids: {
          prop: 'pt_adv_ids',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            multiple: true,
            filterable: true,
            collapseTags: true,
            placeholder: '请输入pt广告主名称',
            class: 'search-filter-select',
          },
        },
        template_id: {
          type: 'input',
          prop: 'template_id',
          params: {
            clearable: true,
            placeholder: '请输入模板/创意ID',
          },
        },
        template_name: {
          type: 'input',
          prop: 'template_name',
          params: {
            clearable: true,
            placeholder: '请输入模板/创意名称',
          },
        },
        project_name: {
          type: 'input',
          prop: 'project_name',
          params: {
            clearable: true,
            placeholder: '请输入版本/作品名称',
          },
        },
        mid: {
          type: 'input',
          prop: 'mid',
          params: {
            clearable: true,
            placeholder: '请输入mid',
          },
        },
        package_name: {
          type: 'input',
          prop: 'package_name',
          params: {
            clearable: true,
            placeholder: '请输入包名',
          },
        },
        uuid: {
          type: 'input',
          prop: 'uuid',
          params: {
            clearable: true,
            placeholder: '请输入offer uuid',
          },
        },
        platforms: {
          type: 'business',
          subtype: 'platform-selector',
          prop: 'platforms',
          params: {
            placeholder: '请选择offer投放平台',
            clearable: true,
            multiple: true,
            collapseTags: true,
            options: platforms,
          },
        },
        country_codes: {
          type: 'select',
          prop: 'country_codes',
          params: {
            placeholder: '请选择offer投放国家',
            clearable: true,
            multiple: true,
            filterable: true,
            collapseTags: true,
            class: 'search-filter-select',
            options: this.countryList,
          },
        },
        adv_creative_id: {
          type: 'input',
          prop: 'adv_creative_id',
          params: {
            clearable: true,
            placeholder: '请输入素材Id',
          },
        },
        adv_creative_name: {
          type: 'input',
          prop: 'adv_creative_name',
          params: {
            clearable: true,
            placeholder: '请输入素材名称',
          },
        },
        ad_types: {
          type: 'select',
          prop: 'ad_types',
          params: {
            placeholder: '请选择广告类型',
            clearable: true,
            options: adTypesOptions,
          },
        },
        app_id: {
          type: 'input',
          prop: 'app_id',
          params: {
            clearable: true,
            placeholder: '请输入app id',
          },
        },
        app_name: {
          type: 'input',
          prop: 'app_name',
          params: {
            clearable: true,
            placeholder: '请输入app name',
          },
        },
        traffic_source: {
          prop: 'traffic_source',
          type: 'select',
          params: {
            clearable: true,
            placeholder: '请选择流量来源',
            options: trafficTypeOptions,
          },
        },
        provider_ids: {
          type: 'select',
          prop: 'provider_ids',
          params: {
            clearable: true,
            placeholder: '请输入素材供应商',
            options: this.creativeProvider,
          },
        },
        is_dco: {
          type: 'select',
          prop: 'is_dco',
          params: {
            clearable: true,
            placeholder: '是否DCO',
            options: [
              {
                label: 'YES（DCO）',
                value: 1,
              },
              {
                label: 'No（DCO）',
                value: 2,
              },
            ],
          },
        },
        dco_id: {
          type: 'input',
          prop: 'dco_id',
          params: {
            clearable: true,
            placeholder: '请输入DCOID',
          },
        },
        offer_id: {
          type: 'input',
          prop: 'offer_id',
          params: {
            clearable: true,
            placeholder: '请输入Offer ID',
          },
        },
        basic_id: {
          type: 'input',
          prop: 'basic_id',
          params: {
            clearable: true,
            placeholder: '请输入基础包ID',
          },
        },
        demand_id: {
          type: 'input',
          prop: 'demand_id',
          params: {
            clearable: true,
            placeholder: '请输入需求ID',
          },
        },
      }
      return list
    },
    // 基础埋点内容
    basicList() {
      return [
        {
          label: '开始渲染',
          prop: 'pv',
        },
        {
          label: '渲染完成',
          prop: 'ir',
        },
        {
          label: '渲染成功率',
          prop: 'render_rate',
        },
        {
          label: '渠道展示',
          prop: 'ws',
        },
        {
          label: '试玩展示',
          prop: 'gs',
        },
        {
          label: '第一次交互',
          prop: 'fc',
        },
        {
          label: 'TTE1',
          prop: 'tte1',
        },
        {
          label: 'TTE2',
          prop: 'tte2',
        },
        {
          label: '试玩完成率',
          prop: 'trial_finish_rate',
        },
        {
          label: '跳转商店',
          prop: 'click_install',
        },
        {
          label: '试玩过程跳转',
          prop: 'click_install_playing',
        },
        {
          label: '结束页跳转',
          prop: 'click_install_ending',
        },
        {
          label: 'Storekit跳转',
          prop: 'click_install_storekit',
        },
        {
          label: '试玩结束数',
          prop: 'ge',
        },
        {
          label: '试玩时长',
          prop: 'play_time',
        },
        {
          label: 'TTE3',
          prop: 'tte3',
        },
        {
          label: '平均有效交互次数',
          prop: 'vi',
        },
        {
          label: '重新试玩数',
          prop: 'replay',
        },
        {
          label: '交互前流失数',
          prop: 'loss_fi',
        },
        {
          label: '交互后流失数',
          prop: 'loss_after_fi',
        },
        {
          label: '试玩时流失数',
          prop: 'loss_playing',
        },
        {
          label: '试玩结束流失数',
          prop: 'loss_ending',
        },
      ]
    },

    sceneList() {
      // 场景埋点
      let sceneList = []
      const cookScene = (num) => {
        return [
          {
            label: `场景${num}到达数`,
            prop: `scene${num}_imp`,
          },
          {
            label: `场景${num}流失数`,
            prop: `scene${num}_lose`,
          },
          {
            label: `场景${num}转化数`,
            prop: `scene${num}_install`,
          },
          {
            label: `场景${num}到达率`,
            prop: `scene${num}_arrive_rate`,
          },
          {
            label: `场景${num}流失率`,
            prop: `scene${num}_lose_rate`,
          },
          {
            label: `场景${num}转化率`,
            prop: `scene${num}_conversion_rate`,
          },
          {
            label: `场景${num}跳转时长`,
            prop: `scene${num}_stay_time`,
          },
        ]
      }
      for (let i = 1; i <= 10; i++) {
        sceneList = sceneList.concat(cookScene(i))
      }
      return sceneList
    },

    // 自定义埋点
    actionList() {
      return [
        {
          label: 'action1',
          prop: 'action1',
        },
        {
          label: 'action2',
          prop: 'action2',
        },
        {
          label: 'action3',
          prop: 'action3',
        },
        {
          label: 'action4',
          prop: 'action4',
        },
        {
          label: 'action5',
          prop: 'action5',
        },
        {
          label: 'action6',
          prop: 'action6',
        },
        {
          label: 'action7',
          prop: 'action7',
        },
        {
          label: 'action8',
          prop: 'action8',
        },
        {
          label: 'action9',
          prop: 'action9',
        },
        {
          label: 'action10',
          prop: 'action10',
        },
        {
          label: 'action11',
          prop: 'action11',
        },
        {
          label: 'action12',
          prop: 'action12',
        },
        {
          label: 'action13',
          prop: 'action13',
        },
        {
          label: 'action14',
          prop: 'action14',
        },
        {
          label: 'action15',
          prop: 'action15',
        },
      ]
    },

    tableColumnConfig() {
      const self = this
      const tableList = [
        {
          label: '日期',
          prop: 'date',
        },
        {
          label: '素材类型',
          prop: 'creative_type',
          params: {
            innerHTML({ row }) {
              const temp = categories.find(
                (item) => item.value === row.creative_type,
              )
              return temp ? temp.label : '-'
            },
          },
        },
        {
          label: 'Ss广告主名称',
          prop: 'ss_adv_id',
          params: {
            innerHTML({ row }) {
              return row.ss_adv_name || '-'
            },
          },
        },
        {
          label: 'Pt广告主名称',
          prop: 'pt_adv_id',
          params: {
            innerHTML({ row }) {
              return row.pt_adv_name || '-'
            },
          },
        },
        {
          label: '模板/创意 ID',
          prop: 'template_id',
          params: {
            innerHTML({ row }) {
              return row.template_id || '-'
            },
          },
        },
        {
          label: '模板/创意名称',
          prop: 'template_name',
          params: {
            innerHTML({ row }) {
              return row.template_name || '-'
            },
          },
        },
        {
          label: '版本/作品名称',
          prop: 'project_id',
          params: {
            innerHTML({ row }) {
              return row.project_name || '-'
            },
          },
        },
        {
          label: 'Mid',
          prop: 'mid',
        },
        {
          label: '包名',
          prop: 'package_name',
        },
        {
          label: 'Uuid',
          prop: 'uuid',
        },
        {
          label: '投放平台',
          prop: 'platform',
          params: {
            innerHTML({ row }) {
              const temp = platforms.find((item) => item.value === row.platform)
              return temp ? temp.label : '-'
            },
          },
        },
        {
          label: '投放国家',
          prop: 'country_code',
        },
        {
          label: '素材Id',
          prop: 'adv_creative_id',
        },
        {
          prop: 'adv_creative_name',
          slot: 'adv_creative_name',
        },
        {
          label: '广告类型',
          prop: 'ad_type',
          params: {
            innerHTML({ row }) {
              const temp = adTypesOptions.find(
                (item) => item.value === row.ad_type,
              )
              return temp ? temp.label : '-'
            },
          },
        },
        {
          label: 'App Id',
          prop: 'app_id',
        },
        {
          label: 'App Name',
          prop: 'app_name',
        },
        {
          label: '流量源',
          prop: 'traffic_source',
          params: {
            innerHTML({ row }) {
              const temp = trafficTypeOptions.find(
                (item) => item.value === row.traffic_source,
              )
              return temp ? temp.label : '-'
            },
          },
        },
        {
          label: '素材供应商',
          prop: 'provider_id',
          params: {
            innerHTML({ row }) {
              const provider = self.creativeProvider.find(
                (item) => item.value === row.provider_id,
              )
              const temp = self.creativeProvider ? provider : ''
              return temp ? temp.label : '-'
            },
          },
        },
        {
          label: 'Offer ID',
          prop: 'offer_id',
        },
        {
          label: '基础包ID',
          prop: 'basic_id',
        },
        {
          label: '需求ID',
          prop: 'demand_id',
        },
        {
          label: 'App tag',
          prop: 'app_tag',
          params: {
            innerHTML({ row }) {
              return `${row.first_tag || '-'}/${row.second_tag || '-'}/${
                row.third_tag || '-'
              }`
            },
          },
        },
        {
          label: 'Project tag',
          prop: 'project_tag',
          params: {
            innerHTML({ row }) {
              return `${row.project_tag || '-'}/${row.sub_category || '-'}`
            },
          },
        },
        {
          label: 'Impression',
          prop: 'impression',
        },
        {
          label: 'Click',
          prop: 'click',
        },
        {
          label: 'Install',
          prop: 'install',
        },
        {
          label: 'Rev',
          prop: 'revenue',
        },
        {
          label: 'CTR',
          prop: 'ctr',
        },
        {
          label: 'CVR',
          prop: 'cvr',
        },
        {
          label: 'IVR',
          prop: 'ivr',
        },
        {
          label: 'eCPM',
          prop: 'ecpm',
        },
      ]

      const checkSortColumn = (prop) => {
        if (this.query.agg_type === 'date') {
          return true
        }
        return prop !== 'date'
      }

      const checkVisibleColumn = (prop) => {
        const visibleColumns = [...this.visibleColumns, 'date']
        const hasBasics = this.visibleColumns.some((val) => val === 'basics')
        const hasScene = this.visibleColumns.some((val) => val === 'scenes')
        const hasAction = this.visibleColumns.some((val) => val === 'actions')
        return (
          visibleColumns
            .concat(
              hasBasics ? this.basicList.map((item) => item.prop) : [],
              hasScene ? this.sceneList.map((item) => item.prop) : [],
              hasAction ? this.actionList.map((item) => item.prop) : [],
            )
            .indexOf(prop) > -1
        )
      }

      // 格式化字段
      const dataFormat = [
        'impression',
        'click',
        'install',
        'revenue',
        'pv',
        'ir',
        'ws',
        'gs',
        'ge',
        'click_install',
        'click_install_playing',
        'click_install_ending',
        'click_install_storekit',
      ]
      const percentFormat = ['ctr', 'cvr', 'ivr']
      return tableList
        .concat(this.basicList, this.sceneList, this.actionList)
        .map((item) => {
          const temp = {
            minWidth: 130,
            ...item,
            visible: checkVisibleColumn(item.prop),
            sortable: checkSortColumn(item.prop) ? 'custom' : false,
            dataFormat:
              dataFormat.indexOf(item.prop) > -1
                ? { thousandsSeparator: true }
                : '',
          }
          // 百分比
          if (
            percentFormat.indexOf(item.prop) > -1 ||
            item.prop.indexOf('rate') > -1
          ) {
            temp.params = temp.params || {}
            temp.params.innerHTML = ({ row }) => {
              return row[item.prop] || row[item.prop] === 0
                ? fmtPercent(row[item.prop])
                : '-'
            }
          }
          // 收益列添加2位小数
          if (item.prop === 'revenue') {
            temp.dataFormat =
              dataFormat.indexOf(item.prop) > -1
                ? { thousandsSeparator: true, decimals: 2 }
                : ''
          }
          // 场景埋点列增加宽度
          if (item.prop.indexOf('scene') > -1) {
            temp.minWidth = 140
          }
          // 汇总列
          if (item.prop === 'date') {
            temp.minWidth = 60
            temp.params = temp.params || {}
            temp.params.innerHTML = ({ row }) => {
              return row[item.prop] || '-'
            }
          }
          return temp
        })
    },

    dataDimension() {
      const _d = [
        {
          label: '素材类型',
          value: 'creative_type',
        },
        {
          label: 'ss广告主名称',
          value: 'ss_adv_id',
        },
        {
          label: 'pt广告主名称',
          value: 'pt_adv_id',
        },
        {
          label: '模板/创意名称',
          value: 'template_id',
        },
        {
          label: '版本/作品名称',
          value: 'project_id',
        },
        {
          label: 'mid',
          value: 'mid',
        },
        {
          label: '包名',
          value: 'package_name',
        },
        {
          label: 'UUID',
          value: 'uuid',
        },
        {
          label: '投放平台',
          value: 'platform',
        },
        {
          label: '投放国家',
          value: 'country_code',
        },
        {
          label: 'Adv creativeId',
          value: 'adv_creative_id',
        },
        {
          label: 'Adv creativename',
          value: 'adv_creative_name',
        },
        {
          label: 'Ad type',
          value: 'ad_type',
        },
        {
          label: '流量app id',
          value: 'app_id',
        },
        {
          label: '流量app name',
          value: 'app_name',
        },
        {
          label: '流量源',
          value: 'traffic_source',
        },
        {
          label: '素材供应商',
          value: 'provider_id',
        },
        {
          label: 'DCO素材',
          value: 'is_dco',
        },
        {
          label: 'DCOID',
          value: 'dco_id',
        },
        {
          label: 'Offer ID',
          value: 'offer_id',
        },
        {
          label: '基础包ID',
          value: 'basic_id',
        },
        {
          label: '需求ID',
          value: 'demand_id',
        },
        {
          label: 'app tag',
          value: 'app_tag',
        },
        {
          label: 'project tag',
          value: 'project_tag',
        },
      ]
      return _d
    },

    columnList() {
      return [
        {
          label: 'Impression',
          value: 'impression',
        },
        {
          label: 'Click',
          value: 'click',
        },
        {
          label: 'Install',
          value: 'install',
        },
        {
          label: 'Rev',
          value: 'revenue',
        },
        {
          label: 'CTR',
          value: 'ctr',
        },
        {
          label: 'CVR',
          value: 'cvr',
        },
        {
          label: 'IVR',
          value: 'ivr',
        },
        {
          label: 'ECPM',
          value: 'ecpm',
        },
        {
          label: '基础埋点',
          value: 'basics',
        },
        {
          label: '场景埋点',
          value: 'scenes',
        },
        {
          label: '自定义埋点',
          value: 'actions',
        },
      ]
    },

    timeZoneList() {
      return this.$store.state.config.timeZoneList || []
    },
  },
  methods: {},
  watch: {
    $route(to, from) {
      // 跳转之后更新一次 query 值，保证 query 是最新的，除了 page 与 page_size 其它的都没有默认值
      const toQuery = this._cookQuery(
        Object.assign({}, to.query, defaultQuery(to.query)),
      )
      const temp = _.assignWith(
        toQuery,
        this.cloneQuery,
        (objValue, srcValue) => {
          // 如果为 undefined，就将 query 相对应的属性值设置为空字符串或空数组
          if (_.isUndefined(objValue)) {
            if (_.isArray(srcValue)) return []
            return ''
          }

          // 如果 toQuery 的某个属性值有值，判断该值是否与初始化定义的值的类型一致（只有数组/数字/字符串）。如果是数组，有一个特殊的地方，如多选组件只选了一个选项，那么 to.query 上的该值现为字符串，不是数组，会导致代码出错，需要强行将其转换为数组
          let val = ''
          // 有值时，类型不匹配
          if (_.isArray(srcValue) && !_.isArray(objValue)) {
            if (objValue) {
              val = [objValue]
            } else {
              val = []
            }
          } else {
            val = objValue
          }

          return val
        },
      )
      if (temp.tz) {
        temp.tz = String(temp.tz)
      }
      this.query = temp
    },
  },
}
